
import * as React from "react";
import { IComboBoxValues, ComboBox } from "../../../avernus/combobox/source/ComboBox";
import { Api } from "../../lib/Api";

export interface IItem {
    id             : number
    name           : string
}


interface IXHR{
    error   :string
    success :string
}

interface IAddMoreCompProps {
    id                          : number
    xhrGetListForSelect         : string
    xhrGetListForSelectPostData?: any
    xhrGetItems                 : string
    xhrAdd                      : string
    xhrRemove                   : string
}

interface IAddMoreCompState {
    error       : string
    success     : string
    currentValue: string
    currentLabel: string
    source      : Array<IComboBoxValues>
    items       : Array<IItem>
}

interface IgetListResult{
    items          : Array<IComboBoxValues>
}
interface IgetItems{
    items          : Array<IItem>
}


export default class AddMoreComp extends React.Component<IAddMoreCompProps, IAddMoreCompState>{

  	constructor(props:IAddMoreCompProps){
        super(props);
        this.state = {
            success     : null,
            error       : null,
            currentValue: '0',
            currentLabel: '',
            source      : null,
            items       : null
		};
        this.init();
    }

    private init(){
        let postData = {};
        if ( this.props.xhrGetListForSelectPostData !== undefined ) {
            postData = this.props.xhrGetListForSelectPostData;
        }
        Api.call(this.props.xhrGetListForSelect, postData, (result:IgetListResult)=>{
            this.setState({
                source: result.items
            }, () =>{
                this.getItems();
            });
        });
    }
    private getItems(){
        Api.call(this.props.xhrGetItems, {
            id  : this.props.id
        }, (result:IgetItems)=>{
            this.setState({
                items: result.items
            });
        });
    }

    private modifSource(value:string, label:string): void {
        this.setState({
             currentValue: value,
             currentLabel: label,
        });
    }

    private addConnectionClickHandler(evt): void {
        evt.preventDefault();
        let connectId = parseInt(this.state.currentValue);
        if ( connectId > 0 ) {
            Api.call(this.props.xhrAdd, {
                id  : this.props.id,
                connectId: connectId
            }, (result:IXHR)=>{
            this.setState({
                 success: result.success,
                 error  : result.error
            }, ()=>{
                if ( this.state.success !== null ) {
                    this.setState({
                        currentValue: '0',
                        currentLabel: '',
                    }, ()=>{
                        this.getItems();
                    });
                }else{
                    this.getItems();
                }
            });
        });
        }
    }

    private removeItemClickHandler(evt, connectId:number): void {
        evt.preventDefault();
        Api.call(this.props.xhrRemove, {
            id  : this.props.id,
            connectId: connectId
        }, (result:IXHR)=>{
            this.setState({
                success: result.success,
                error  : result.error
            }, ()=>{
                this.getItems();
            });
        });
    }

    private removeDuplication(sources:Array<IComboBoxValues>):Array<IComboBoxValues>{
        let ret:Array<IComboBoxValues> = []
        for (var key in sources) {
            var source  = sources[key];
            let founded = false;
            for (var ikey in this.state.items) {
                var item = this.state.items[ikey];
                if ( parseInt(source.value) === item.id ) {
                    founded = true;
                    break;
                }
            }
            if (founded === false) {
                ret.push(source);
            }
        }

        return ret;
    }


    render() {
        let connectId = parseInt(this.state.currentValue);
        let source = this.state.source !== null?this.removeDuplication(this.state.source):[];
        return (
            <>
                { this.state.source !== null?<>
                    <form>
                        <div className="row">
                            <div className="col-xl-12" style={{marginTop: '15px'}}>
                                <div className="input-group">
                                    <ComboBox
                                        key={'restaurant_filter_' + source.length }
                                        selectMode      = {false}
                                        placeholder     = "Restaurant name …"
                                        currentValue    = { this.state.currentValue }
                                        currentLabel    = { this.state.currentLabel }
                                        source={source}
                                        changed         = { (value, label) => this.modifSource(value, label) }
                                    />
                                    <div className="input-group-append">
                                        <button className="btn btn-primary btn-sm" disabled={connectId===0?true:false} type="button" onClick={ e => this.addConnectionClickHandler(e) }
                                        ><i className="icon ion-plus"></i></button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12">
                                { this.state.error !== null?<div className="alert alert-danger" style={{marginTop:'10px'}}>
                                        { this.state.error }
                                </div>:''}
                                { this.state.success !== null?<div className="alert alert-success" style={{marginTop:'10px'}}>
                                        { this.state.success }
                                </div>:''
                                }
                            </div>
                        </div>
                    </form>

                <div className="row">
                    <div className="col-xl-12" style={{marginTop: '15px'}}>
                        { this.state.items !== null?<div className="table-responsive gray_table">
                            <table className="table _table-striped table-sm">
                                <tbody>
                                    { this.state.items.map((item, index) =>{
                                        return <tr key={index}>

                                            <td>
                                                { item.name }
                                            </td>

                                            <td style={{
                                                width: '42px'
                                            }}>
                                                <button className="btn btn-warning btn-sm" type="button" onClick={ e => this.removeItemClickHandler(e, item.id) }
                                                >
                                                    <i className="icon ion-trash-b"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    })}
                                </tbody>
                            </table>
                        </div>:'Loading ...' }


                    </div>
                </div>
                </>:'Loading...' }

			</>
        );
    }
}
